import React, {Component} from 'react';
import IconMapEnlarge from '@spothero/icons/map-enlarge';
import Button from '@spothero/ui/button';
import PropTypes from 'prop-types';
import SpotDetailsDirectionsMap from './SpotDetailsDirectionsMap';
import SpotDetailsDirectionsMapModal from './SpotDetailsDirectionsMapModal';

export default class SpotDetailsPanelMap extends Component {
    static propTypes = {
        spotLatitude: PropTypes.number.isRequired,
        spotLongitude: PropTypes.number.isRequired,
        destinationLatitude: PropTypes.number.isRequired,
        destinationLongitude: PropTypes.number.isRequired,
        isDriving: PropTypes.bool,
        distance: PropTypes.number,
        distanceInMiles: PropTypes.number,
        walkingDuration: PropTypes.oneOfType([
            PropTypes.number,
            PropTypes.string,
        ]),
    };
    state = {
        showModal: false,
    };

    _onModalHidden = () => {
        this.setState({
            showModal: false,
        });
    };

    _onClick = evt => {
        this.setState({
            showModal: true,
        });
    };

    render() {
        const {
            spotLatitude,
            spotLongitude,
            destinationLatitude,
            destinationLongitude,
            isDriving,
            distance,
            distanceInMiles,
            walkingDuration,
        } = this.props;
        const walkingProps = {
            distance,
            distanceInMiles,
            walkingDuration,
        };

        return (
            <div className="SpotDetailsPanelMap">
                <SpotDetailsDirectionsMap
                    spotLatitude={spotLatitude}
                    spotLongitude={spotLongitude}
                    destinationLatitude={destinationLatitude}
                    destinationLongitude={destinationLongitude}
                    isDriving={isDriving}
                    disableDefaultUI
                    onClick={this._onClick}
                    {...(!isDriving && walkingProps)}
                />
                <Button
                    className="SpotDetailsPanelMap-enlarge"
                    onClick={this._onClick}
                >
                    <IconMapEnlarge />
                </Button>
                {this.state.showModal && (
                    <SpotDetailsDirectionsMapModal
                        spotLatitude={spotLatitude}
                        spotLongitude={spotLongitude}
                        destinationLatitude={destinationLatitude}
                        destinationLongitude={destinationLongitude}
                        isDriving={isDriving}
                        onHidden={this._onModalHidden}
                        {...(!isDriving && walkingProps)}
                    />
                )}
            </div>
        );
    }
}
